import React from 'react';
import {
    closeContactDetails,
    getGroup,
    groupIsMember,
    openContactDetails,
    triggerMenuOption,
} from '../stores/contacts-slice-handler';
import classNames from 'classnames';
import { computeUserName, getLoggedInMsisdn } from '../../../utils/contact-util';
import t from 'utils/translate';
import { ContactMenuOption } from '../../../constants/contacts-constants';
import ContactMenu from './contact-menu';
import { useSelector } from 'react-redux';
import { sortByProperty } from '../../../utils/functions';
import ContactUserPicture from './contact-user-picture';

/**
 *
 * @param {number} groupId
 * @return {JSX.Element}
 * @constructor
 */
export default function ContactDetailsGroup({ groupId }) {
    // make sure that the contact is kept in link with the store
    const group = useSelector(() => getGroup(groupId));

    if (group === null) {
        return '';
    }

    const membersSummary = () => {
        let groupsLabel =
            group.ChildGroups.length === 1
                ? t('js_all_details_group_groups_count_single')
                : t('js_all_details_group_groups_count_multiple').replace('%count%', group.ChildGroups.length);
        let usersLabel =
            group.Members.length === 1
                ? t('js_all_details_group_users_count_single')
                : t('js_all_details_group_users_count_multiple').replace('%count%', group.Members.length);

        return `${groupsLabel}, ${usersLabel}`;
    };

    const menuOptionClick = (contact, feature) => {
        triggerMenuOption(contact, feature);
        closeContactDetails();
    };

    return (
        <>
            <div className={'contact-details-content'}>
                <div
                    className={classNames({
                        'contact-group-item': true,
                        'as-avatar': true,
                        'with-membership': groupIsMember(group.GroupId),
                    })}
                >
                    <div className={'group-icon-container main-avatar'}>
                        <span className={'stw-group'}></span>
                    </div>
                </div>
                <div className={'contact-name-container'}>{group.Name}</div>
                <div className={'group-members-summary'} data-test-id="group-members-summary">
                    {membersSummary()}
                </div>
                <ContactMenu
                    contact={group}
                    linear
                    optionClick={menuOptionClick}
                    ignoredOptions={[
                        // decikatals are open, no need this button
                        ContactMenuOption.DETAILS,
                        // these trigger CUG update, and we do not want that while details are open
                        ContactMenuOption.ADD_TO_FAVORITES,
                        ContactMenuOption.REMOVE_FROM_FAVORITES,
                        ContactMenuOption.ADD_TO_CONTACTS,
                        ContactMenuOption.REMOVE_FROM_CONTACTS,
                        ContactMenuOption.USER_GROUP_EDIT,
                        ContactMenuOption.USER_GROUP_DELETE,
                    ]}
                />
                <div className={'group-members-table'}>
                    <table>
                        <tbody>
                            {sortByProperty([...group.ChildGroups], 'Name').map((childGroup) => {
                                return (
                                    <tr
                                        onClick={() => openContactDetails(childGroup.GroupId, true)}
                                        key={`child-group-${childGroup.GroupId}`}
                                    >
                                        <td>
                                            <div
                                                className={classNames({
                                                    'contact-group-item': true,
                                                    'as-child-group': true,
                                                    'with-membership': groupIsMember(childGroup.GroupId),
                                                })}
                                            >
                                                <div className={'group-icon-container'}>
                                                    <span className={'stw-group'}></span>
                                                </div>
                                                <div className={'group-name-container'}>{childGroup.Name}</div>
                                            </div>
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                );
                            })}
                            {sortByProperty([...group.Members], 'FirstName').map((userMember) => {
                                return (
                                    <tr
                                        onClick={() => openContactDetails(userMember.Msisdn, true)}
                                        key={`user-member-${userMember.Msisdn}`}
                                    >
                                        <td>
                                            <div
                                                className={'contact-user-item as-group-member'}
                                                data-test-id={`group-member-${userMember.Msisdn}`}
                                            >
                                                <ContactUserPicture msisdn={userMember.Msisdn} />
                                                <div className={'user-name-container'}>
                                                    <span>{computeUserName(userMember)}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{userMember.Position}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="footer-bar">
                <div className="ok-button" onClick={() => closeContactDetails()}>
                    {t('js_all_ok_button')}
                </div>
            </div>
        </>
    );
}
